import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mst_item_entity_pricing_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_line_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  sales_unit_price: fromDatatype.NumericDatatypeInterface;
  sales_max_price: fromDatatype.NumericDatatypeInterface;
  sales_min_price: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price: fromDatatype.NumericDatatypeInterface;
  purchase_max_price: fromDatatype.NumericDatatypeInterface;
  purchase_min_price: fromDatatype.NumericDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  entity_item_code: fromDatatype.VarcharDatatypeInterface;
  entity_item_name: fromDatatype.VarcharDatatypeInterface;
  sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sale_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_excl_tax: fromDatatype.NumericDatatypeInterface;
  input_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  entity_item_guid: fromDatatype.GuidDataFieldInterface;
  entity_item_pk: fromDatatype.VarcharDatatypeInterface;
  entity_barcode: fromDatatype.VarcharDatatypeInterface;
  consignment_qty_max: fromDatatype.IntegerDatatypeInterface;
  consignment_qty_min: fromDatatype.IntegerDatatypeInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  sales_order_lead_time_day: fromDatatype.IntegerDatatypeInterface;
  sales_order_lead_time_hour: fromDatatype.IntegerDatatypeInterface;
  sales_qty_min_order: fromDatatype.NumericDatatypeInterface;
  sales_qty_max_order: fromDatatype.NumericDatatypeInterface;
  sales_qty_reorder_level: fromDatatype.NumericDatatypeInterface;
  sales_qty_reorder_volume: fromDatatype.NumericDatatypeInterface;
  sales_qty_per_month: fromDatatype.NumericDatatypeInterface;
  sales_qty_per_year: fromDatatype.NumericDatatypeInterface;
  sales_qty_per_decade: fromDatatype.NumericDatatypeInterface;
  purchase_order_lead_time_day: fromDatatype.IntegerDatatypeInterface;
  purchase_order_lead_time_hour: fromDatatype.IntegerDatatypeInterface;
  purchase_qty_min_order: fromDatatype.NumericDatatypeInterface;
  purchase_qty_max_order: fromDatatype.NumericDatatypeInterface;
  purchase_qty_reorder_level: fromDatatype.NumericDatatypeInterface;
  purchase_qty_reorder_volume: fromDatatype.NumericDatatypeInterface;
  purchase_qty_per_month: fromDatatype.NumericDatatypeInterface;
  purchase_qty_per_year: fromDatatype.NumericDatatypeInterface;
  purchase_qty_per_decade: fromDatatype.NumericDatatypeInterface;
  sales_consignment_qty_allocation: fromDatatype.NumericDatatypeInterface;
  sales_consignment_qty_reorder_level: fromDatatype.NumericDatatypeInterface;
  sales_consignment_qty_reorder_volume: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_max_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface; 
  sales_min_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface; 
  sales_price_before_discount_wht_tax_amt: fromDatatype.NumericDatatypeInterface; 
  purchase_unit_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface; 
  purchase_max_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface; 
  purchase_min_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface; 
  supplier_priority: fromDatatype.BigIntegerDatatypeInterface;
}

export class bl_fi_mst_item_entity_pricing_link_RowClass implements bl_fi_mst_item_entity_pricing_link_RowInterface {

  guid: fromDatatype.GuidDataFieldInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_line_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  sales_unit_price: fromDatatype.NumericDatatypeInterface;
  sales_max_price: fromDatatype.NumericDatatypeInterface;
  sales_min_price: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price: fromDatatype.NumericDatatypeInterface;
  purchase_max_price: fromDatatype.NumericDatatypeInterface;
  purchase_min_price: fromDatatype.NumericDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  entity_item_code: fromDatatype.VarcharDatatypeInterface;
  entity_item_name: fromDatatype.VarcharDatatypeInterface;
  sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sale_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_excl_tax: fromDatatype.NumericDatatypeInterface;
  input_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  entity_item_guid: fromDatatype.GuidDataFieldInterface;
  entity_item_pk: fromDatatype.VarcharDatatypeInterface;
  entity_barcode: fromDatatype.VarcharDatatypeInterface;
  consignment_qty_max: fromDatatype.IntegerDatatypeInterface;
  consignment_qty_min: fromDatatype.IntegerDatatypeInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  sales_order_lead_time_day: fromDatatype.IntegerDatatypeInterface;
  sales_order_lead_time_hour: fromDatatype.IntegerDatatypeInterface;
  sales_qty_min_order: fromDatatype.NumericDatatypeInterface;
  sales_qty_max_order: fromDatatype.NumericDatatypeInterface;
  sales_qty_reorder_level: fromDatatype.NumericDatatypeInterface;
  sales_qty_reorder_volume: fromDatatype.NumericDatatypeInterface;
  sales_qty_per_month: fromDatatype.NumericDatatypeInterface;
  sales_qty_per_year: fromDatatype.NumericDatatypeInterface;
  sales_qty_per_decade: fromDatatype.NumericDatatypeInterface;
  purchase_order_lead_time_day: fromDatatype.IntegerDatatypeInterface;
  purchase_order_lead_time_hour: fromDatatype.IntegerDatatypeInterface;
  purchase_qty_min_order: fromDatatype.NumericDatatypeInterface;
  purchase_qty_max_order: fromDatatype.NumericDatatypeInterface;
  purchase_qty_reorder_level: fromDatatype.NumericDatatypeInterface;
  purchase_qty_reorder_volume: fromDatatype.NumericDatatypeInterface;
  purchase_qty_per_month: fromDatatype.NumericDatatypeInterface;
  purchase_qty_per_year: fromDatatype.NumericDatatypeInterface;
  purchase_qty_per_decade: fromDatatype.NumericDatatypeInterface;
  sales_consignment_qty_allocation: fromDatatype.NumericDatatypeInterface;
  sales_consignment_qty_reorder_level: fromDatatype.NumericDatatypeInterface;
  sales_consignment_qty_reorder_volume: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_max_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface; 
  sales_min_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface; 
  sales_price_before_discount_wht_tax_amt: fromDatatype.NumericDatatypeInterface; 
  purchase_unit_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface; 
  purchase_max_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface; 
  purchase_min_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface; 
  supplier_priority: fromDatatype.BigIntegerDatatypeInterface
}
